import { TextareaAutosize } from '@mui/material';
import classNames from 'classnames';

export type TextareaVariant = 'default' | 'modal';

type TextareaProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  maxLength?: number;
  minRows?: number;
  disabled?: boolean;
  autoFocus?: boolean;
  variant?: TextareaVariant;
  className?: string;
};

const Textarea = ({
  value,
  onChange,
  placeholder,
  maxLength,
  minRows = 3,
  disabled,
  autoFocus,
  variant = 'default',
  className,
}: TextareaProps) => (
  <div className={classNames('ui-kit-textarea', `ui-kit-textarea--${variant}`, className)}>
    <TextareaAutosize
      className="ui-kit-textarea__input"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      maxLength={maxLength}
      minRows={minRows}
      disabled={disabled}
      autoFocus={autoFocus}
      onPointerEnterCapture={undefined}
      onPointerLeaveCapture={undefined}
      onResize={undefined}
      onResizeCapture={undefined}
    />
    {maxLength !== undefined && (
      <span className="ui-kit-textarea__char-count">
        {value.length} / {maxLength}
      </span>
    )}
  </div>
);

export default Textarea;
